import React, { ReactNode } from "react";

import { HeaderContainer } from "app/frame/HeaderContainer/HeaderContainer";
import { Footer } from "app/frame/Footer/Footer";

import "./style.scss";
import { Head } from "app/layout/components";
import { defaultMetaData } from "app/main/siteMetaData";
import { AdContainer } from "app/thirdParty/ads/AdContainer";
import { AdTypes } from "app/thirdParty/ads/interfaces";

interface Props {
    metaData?: { [name: string]: string };
    title?: string;
    canonicalUrl?: string;
    className?: string;
    children: ReactNode;
}

/**
 * This component provides a basic page setup.
 * It will load the Roboto font in the head and places all children inside a
 * div container with the class "page" to provide layout.
 */
export const PageBase = ({ canonicalUrl, metaData = defaultMetaData, title, children, className }: Props) => {
    return (
        <React.Fragment>
            <Head metaData={metaData} title={title} canonicalUrl={canonicalUrl} />
            <div id="Tall">
                <AdContainer containerId="Tadspacehead" />
                <AdContainer type={[AdTypes.SKY]} />
                <div id="Tmainbox" className={className}>
                    <HeaderContainer />
                    <div className="pageWrapper">
                        <div className="page">
                            <div id="page">{children}</div>
                            <Footer />
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
